// extracted by mini-css-extract-plugin
export default {"list-of-candidates":"Listofcandidates_list-of-candidates__+rZqg","create-job":"Listofcandidates_create-job__9PIg8"};